import { MDBDataTable } from 'mdbreact';
import React, { Component } from 'react';
//i18n
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { wsPositionsFieldsByRole } from '../../constants/WsPositions_fields';

class WsPositionsList extends Component {
  constructor(props) {
    super(props);
  
    const user = JSON.parse(localStorage.getItem('authUser'));
    const rawRows = props.positionsList;
  
    const formattedRows = rawRows.map((item) => {
      let formattedFaces = item.faces_values;
      try {
        const faces = JSON.parse(item.faces_values);
        formattedFaces = Object.entries(faces)
          .map(([key, val]) => `${key}: ${val}`)
          .join(' • ')
      } catch (e) {
        console.error('Error parsing faces_values:', e);
      }
  
      return {
        ...item,
        faces_values: formattedFaces,
      };
    });
  
    const positions = {
      rows: formattedRows,
      columns: wsPositionsFieldsByRole(user.role_id),
    };
  
    this.state = {
      user,
      positionsList: positions,
    };
  }
  

  render() {
    return (
      <React.Fragment>
        <MDBDataTable
          responsive
          striped
          bordered
          data={this.state.positionsList}
          paginationLabel={[this.props.t('Previous'), this.props.t('Next')]}
          entriesLabel={this.props.t('Show positions')}
          noRecordsFoundLabel={this.props.t('No matching records found')}
          infoLabel={[this.props.t('Showing'), this.props.t('to'), this.props.t('of'), this.props.t('entries')]}
          searchLabel={this.props.t('Search')}
        />
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  return {};
};
export default withRouter(connect(mapStateprops, {})(withNamespaces()(WsPositionsList)));
